export default __webpack_public_path__ + "81a1fcaf2ae0f711f416a3106c25599e.png";